
import { defineComponent, PropType } from "vue";
import MessageMixin from "@/components/inbox/messages/MessageMixin";
import Message from "@/components/inbox/messages/Message.vue";
import { IFileMessage, ITextMessage } from "@chatcaptain/types/dist/chatbot";
import MessageIndicator from "@/components/inbox/messages/MessageIndicator.vue";

export default defineComponent({
  name: "FileMessage",
  components: { Message, MessageIndicator },
  mixins: [MessageMixin],
  props: {
    message: {
      type: Object as PropType<IFileMessage>,
      required: true,
    },
  },
  methods: {
    openInNewTab() {
      window.open(this.message.content.url, "_blank");
    },
  },
});
